'use strict';

var addDomEvent = require('./add-dom-event.cjs');
var eventInfo = require('./event-info.cjs');

function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent.addDomEvent(target, eventName, eventInfo.addPointerInfo(handler), options);
}

exports.addPointerEvent = addPointerEvent;
//# sourceMappingURL=add-pointer-event.cjs.map
